/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import WebViewer from '@pdftron/webviewer';

class PDFtronViewer extends Component {
    viewer = React.createRef();
    state ={

    }
    constructor(props) {
        super(props);
        this.viewer = React.createRef();
        this.instance = null;
    }
    
    
    componentDidMount () {
      WebViewer(
        {
          path: '/lib',
          //initialDoc: '/files/sales-invoice.pdf',
          enableAnnotations: true,
          fullAPI: true,
          loadAsPDF: true,
          enableMeasurement: true,
          licenseKey: 'Sainapse Inc.:OEM:Sainapse::B+:AMS(20250221):7467F9E01F47F4D0533352184F516F2F22929C35DD7C69C287246EAE5AF231F5C7'
          //licenseKey : 'Sainapse Inc.:OEM:Sainapse::B+:AMS(20240221):646739E01F47F4D0D33352184F516F2F22929C35DD7C69C287246EAE5AF231F5C7'
        },
        this.viewer.current,
      ).then((instance)=> {
        this.instance = instance
        this.props.initializeWebViewer(instance)
        const { documentViewer} = instance.Core;
        documentViewer.loadDocument(this.props.src, {
          customHeaders: { 'Authorization': JSON.parse(localStorage.getItem("auth_token")) }
        })
      })
    };


    render() {
        return (
            <div className="PDFtronViewer">
                <div className="webviewer" ref={this.viewer}
                    style={{
                        width: '100%',
                        height: this.props.viewer_height,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#757575',
                    }}
                ></div>
            </div>
        );
    };
}

export default PDFtronViewer